import fetcher from 'request/styles/ranking'
import Site from 'components/common/intro/site'
import Faq from 'components/common/intro/faq'

export default function Styles({ initData }) {
  const t = useI18n()
  const { state, mutate } = useStatic({
    records: [],
    fetching: true,
    loadMoreClick: null
  })

  const { gender, genderStyles } = initData

  useBodyScroll({
    state,
    mutate,
    showLoadMore: true,
    startLimit: 6,
    limit: 18,
    fetcher,
    fetcherParams: () => ({ gender })
  })

  const renderLoading = () => {
    if (state.fetching) return <div className='py-5'><C.Loading /></div>
    if (state.scrollConfig.isFinish) return
    return (
      <div className='py-5 flex justify-center'>
        <C.Button className='w-[90%] md:w-[16rem]' onClick={ state.loadMoreClick }>{ t('page:styles.moreStyles') }</C.Button>
      </div>
    )
  }

  return (
    <>
      <div className='flex justify-center mt-6'>
        <C.ToggleButton
          className='w-[14rem]'
          leftLabel={ t('page:styles.woman') }
          rightLabel={ t('page:styles.man') }
          checked={ gender === 'man' }
          onChange={ isOn => {
            if (isOn){
              h.path.go.styles('man')
              return
            }
            h.path.go.styles()
          } } />
      </div>
      <div className='md:container'>
        { genderStyles.map(tag => (
          <GenderStyle key={ tag.id } tag={ tag } t={ t }/>
        )) }
      </div>

      <div className='container text-[1.2rem] md:text-[1.5rem] font-medium pt-6 text-center md:text-left'>{ t('page:styles.stylesRanking') }</div>
      <div className='mt-2 md:mt-5'>
        { state.records.map(tag => (
          <Row key={ tag.id } tag={ tag } />
        )) }
        { renderLoading() }
      </div>

      <div className='container text-[1.2rem] md:text-[1.5rem] font-medium pt-10 text-center md:text-left'>{ t('page:styles.notFound') }</div>
      <div className='md:container my-5 grid gap-[2px] md:gap-1 grid-cols-2 md:grid-cols-3'>
        { initData.tags.map(tag => (
          <Box key={ tag.id } tag={ tag } />
        )) }
      </div>

      <Site />
      <div className='bg-gray-50'>
        <Faq />
      </div>
    </>
  )
}

const Row = ({ tag }) => (
  <C.Link href={ h.path.style({ id: tag.id }) } noUnderline>
    <div className='pb-3 md:pb-5 hover:bg-gray-100'>
      <div className='sm:container'>
        <div className='py-3 px-2 font-medium text-gray-600 md:text-[1.1rem]'># { tag.name }</div>
        <div className='flex mb-2 space-x-1 md:space-x-2 lg:space-x-3'>
          { tag.covers.map((cover, index) => (
            <Photo
              key={ cover.id }
              src={ cover.firstPhoto.url }
              index={ index }
            />
          )) }
        </div>
      </div>
    </div>
  </C.Link>
)

const Photo = ({ src, index }) => (
  <div className={ cn('w-1/3 sm:w-1/4 shadow sm:rounded-[4px] overflow-hidden', { 'hidden sm:block': index > 2 }) }>
    <C.Image
      src={ src }
      className='pt-[133%]' />
  </div>
)

const GenderStyle = ({ tag, t }) => (
  <>
    <div className='text-[1.2rem] md:text-[1.5rem] font-medium pt-6 pb-4 text-center md:text-left'>{ tag.name }</div>
    <div className='px-3 md:px-0 font-medium text-[1.1rem] md:pt-3 md:text-[1.2rem]'>{ t('page:styles.classic') }</div>
    <div className='w-full flex py-3 md:pb-5 space-x-1'>
      { tag.classicPostCovers.map(cover => (
        <C.Link href={ h.path.post({ id: cover.postId }) } preventDefault
          key={ cover.postId } className='w-1/6'>
          <div onClick={ () => h.openPost({ id: cover.postId }) }>
            <C.Image
              src={ cover.coverUrl }
              className='pt-[133%]'
            />
          </div>
        </C.Link>
      )) }
    </div>

    <div className='px-3 md:px-0 font-medium text-[1.1rem] pt-5 md:pt-3 md:text-[1.2rem]'>{ t('page:styles.popularStyles') }</div>
    <div className='py-3 grid gap-[2px] md:gap-1 grid-cols-2 md:grid-cols-3'>
      { tag.relatedTags.map(relatedTag => (
        <Box key={ relatedTag.id } tag={ relatedTag } />
      )) }
    </div>

    <C.Link href={ h.path.style({ id: tag.id }) } className='pt-3 pb-5 flex justify-center'>
      <C.Button className='w-[90%] md:w-[20rem]'>{ t('page:styles.morePosts', { name: tag.name }) }</C.Button>
    </C.Link>
  </>
)

const Box = ({ tag }) => {
  const renderImage = ({ src, alt, className }) => {
    if (!src) return <div className={ cn('bg-gray-100', className) }></div>
    return <C.Image
      src={ src }
      className={ className }
      alt={ alt }
    />
  }
  return (
    <div className='relative'>
      <div className='flex space-x-[1px] md:space-x-[2px]'>
        <div className='flex-[2_0_0%] m-0'>
          { renderImage({
            src: tag.covers[0]?.firstPhoto.url,
            className: 'pt-[100%]',
            alt: tag.name
          }) }
        </div>
        <div className='flex-1 flex flex-col space-y-[1px] md:space-y-[2px]'>
          { renderImage({
            src: tag.covers[1]?.firstPhoto.url,
            className: 'pt-[100%]',
            alt: tag.name
          }) }
          { renderImage({
            src: tag.covers[2]?.firstPhoto.url,
            className: 'pt-[100%]',
            alt: tag.name
          }) }
        </div>
      </div>
      <C.Link href={ h.path.style({ id: tag.id }) } noUnderline className='absolute inset-0 bg-black/50 text-white flex items-center justify-center text-[1.4rem] opacity-100 hover:backdrop-blur-sm hover:bg-black/70 transition-all'>
        <div className='line-clamp-1'># { tag.name }</div>
      </C.Link>
    </div>
  )
}